import { type Plugin } from "chart.js";

import { getThemeColors } from "../chart-utils";

export const BackgroundPlugin: Plugin<"line"> = {
  id: "backgroundPlugin",
  beforeDraw(chart) {
    const { ctx, chartArea, scales } = chart;

    const left = Math.ceil(chartArea.left);
    const right = Math.floor(chartArea.right);
    const top = Math.ceil(chartArea.top);
    const bottom = Math.floor(chartArea.bottom);
    const radius = 4;

    // Draw X-axis grid lines
    const xScale = Object.values(scales).find((e) => e.axis === "x");

    if (xScale) {
      ctx.save();
      ctx.strokeStyle = getThemeColors().borderTertiary;
      ctx.lineWidth = 1;

      scales.x.ticks.forEach((tick) => {
        const x = scales.x.getPixelForValue(tick.value);
        if (x > left + radius && x < right - radius) {
          ctx.beginPath();
          ctx.moveTo(x, top);
          ctx.lineTo(x, bottom);
          ctx.setLineDash([4, 4]);
          ctx.stroke();
        }
      });

      ctx.restore();
    }

    // Draw Y-axis grid lines
    const yScale = Object.values(scales).find((e) => e.axis === "y");

    if (yScale) {
      ctx.save();
      ctx.strokeStyle = getThemeColors().borderTertiary;
      ctx.lineWidth = 1;

      yScale.ticks.forEach((tick) => {
        const y = yScale.getPixelForValue(tick.value);
        if (y > top + radius && y < bottom - radius) {
          ctx.beginPath();
          ctx.moveTo(left, y);
          ctx.lineTo(right, y);
          ctx.setLineDash([0, 0]);
          ctx.stroke();
        }
      });

      ctx.restore();
    }
  },

  afterDraw(chart) {
    const { ctx, chartArea } = chart;

    const left = Math.ceil(chartArea.left);
    const right = Math.floor(chartArea.right);
    const top = Math.ceil(chartArea.top);
    const bottom = Math.floor(chartArea.bottom);
    const radius = 4;

    // rectangle
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(left + radius, top);
    ctx.arcTo(right, top, right, top + radius, radius);
    ctx.arcTo(right, bottom, right - radius, bottom, radius);
    ctx.arcTo(left, bottom, left, bottom - radius, radius);
    ctx.arcTo(left, top, left + radius, top, radius);
    ctx.closePath();
    ctx.clip();
    ctx.fillStyle = "#D1D4DB26";
    ctx.fill();
    // inset shadow
    ctx.shadowBlur = 25;
    ctx.shadowColor = "rgba(0, 0, 0, 0.6)";
    ctx.lineWidth = 1;
    ctx.strokeStyle = getThemeColors().borderTertiary;
    ctx.stroke();
    ctx.restore();

    // border
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(left + radius, top);
    ctx.arcTo(right, top, right, top + radius, radius);
    ctx.arcTo(right, bottom, right - radius, bottom, radius);
    ctx.arcTo(left, bottom, left, bottom - radius, radius);
    ctx.arcTo(left, top, left + radius, top, radius);
    ctx.closePath();
    ctx.lineWidth = 1;
    ctx.strokeStyle = getThemeColors().borderTertiary;
    ctx.stroke();
    ctx.restore();
  },
};
